import React from "react";
import BottomSheet from "../BottomSheet";
import Card from "../Card/Card";
import moment from "moment";
import { SymptomsOnTimeInterval } from "src/types/symptoms.types";
import { Stethoscope } from "lucide-react";
import {
  DATE_FORMAT_STRING_WITH_DAY,
  DATE_FORMAT_STRING_WITH_YEAR_FIRST,
  TIME_FORMAT_STRING,
} from "src/constants/dataTimeFormats";

interface SymptomLogsBottomSheetProps {
  showBottomSheet: boolean;
  setShowBottomSheet: (show: boolean) => void;
  selectedBlockData: SymptomsOnTimeInterval[];
}

const SymptomLogsBottomSheet: React.FC<SymptomLogsBottomSheetProps> =
  React.memo(
    ({
      showBottomSheet,
      setShowBottomSheet,
      selectedBlockData,
    }: SymptomLogsBottomSheetProps) => {
      const date = selectedBlockData[0]?.date;
      return (
        <BottomSheet
          show={showBottomSheet}
          handleClose={() => setShowBottomSheet(false)}
          showCloseButton={true}
        >
          <div>
            <div className="bg-white rounded-t-lg p-4 min-h-40 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
              <h1 className="text-lg font-semibold">Symptoms Logged</h1>
              <p className="text-sm text-gray-500">
                {moment(date, DATE_FORMAT_STRING_WITH_YEAR_FIRST).format(
                  DATE_FORMAT_STRING_WITH_DAY
                )}
              </p>
              <hr className="my-2" />
              <div className="flex flex-col gap-y-2 py-2">
                {selectedBlockData?.map(
                  (item: SymptomsOnTimeInterval, index: number) => (
                    <Card
                      key={index}
                      stackTitleAndDescription={true}
                      rightIcon={null} // remove passing rightIcon here
                    >
                      <div className="flex items-center bg-white">
                        <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mr-3 flex-shrink-0">
                          {item?.symptoms_info?.symptom_image_url ? (
                            <img
                              src={item?.symptoms_info?.symptom_image_url}
                              alt="symptom"
                              className="h-8 w-8 object-contain"
                            />
                          ) : (
                            <Stethoscope className="h-4 w-4 text-[var(--app-primary)]" />
                          )}
                        </div>

                        {/* Content + Right Icon together in a row */}
                        <div className="flex flex-1 items-center justify-between gap-2 min-w-0">
                          <div className="flex-1 min-w-0 overflow-hidden">
                            <h3 className="text-md font-semibold text-gray-900 truncate">
                              {item?.symptoms_info?.name}
                            </h3>
                            {/* <p className="text-sm text-gray-500 mt-1 truncate">
                              {item.symptoms_info?.data?.your_notes}
                            </p> */}
                          </div>
                          <p className="text-sm text-gray-500 whitespace-nowrap">
                            {moment
                              .utc(item?.symptom_updated)
                              .format(TIME_FORMAT_STRING)}
                          </p>
                        </div>
                      </div>
                    </Card>
                  )
                )}
              </div>
            </div>
          </div>
        </BottomSheet>
      );
    }
  );

export default SymptomLogsBottomSheet;
